import TileArcGISRestClass, * as TileArcGISRestModule from './../../node_modules/ol/source/TileArcGISRest.js';

class TileArcGISRest extends TileArcGISRestClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in TileArcGISRestModule) {
    if (key !== "default") {
        TileArcGISRest[key] = TileArcGISRestModule[key];
    }
}

export default TileArcGISRest;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/TileArcGISRest.js';